/**
 * Which face the login page shows. The loader hands over a link token once,
 * so after a refused redemption the loader no longer holds it; the refusal
 * in the action's answer is what keeps the link step on screen.
 */
export type LoginView =
  | { view: "continue"; linkToken: string }
  | { view: "expired" }
  | { view: "form" };

export function loginView(
  loaderData: {
    redirectTo: string;
    linkToken?: string;
    passwordReset?: boolean;
  },
  actionData: { linkExpired?: boolean; errors?: unknown } | undefined
): LoginView {
  if ("linkToken" in loaderData && loaderData.linkToken) {
    return { view: "continue", linkToken: loaderData.linkToken };
  }
  if (actionData?.linkExpired) return { view: "expired" };
  return { view: "form" };
}
